export default __webpack_public_path__ + "static/media/greeting7.e8bdfb53.png";